import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ParserTextEntry, ParserTextRepository } from '@efficiently/client-api-content';
import { GraphQLClient, GraphqlExecutorService } from '@efficiently/client-core-graphql';

import { SELECT_PARSER_TEXT } from '../graphql/queries';

@Injectable()
export class ParserTextGqlRepository extends ParserTextRepository {
	private readonly gql = inject(GraphqlExecutorService);

	public selectParserText(
		key: string,
		phrases: Set<string> = new Set<string>(),
		x1: number = null,
		x2: number = null,
		y1: number = null,
		y2: number = null,
	): Observable<ParserTextEntry[]> {
		return this.gql.watchOnce(SELECT_PARSER_TEXT, {
			variables: {
				args: {
					key,
					phrases: Array.from(phrases),
					x1,
					x2,
					y1,
					y2,
				},
			},
			client: GraphQLClient.Core,
			select: data => data.selectParserText.entries,
		});
	}
}
